import { useMemo } from "react";
import { useSelector } from "react-redux";

export const EVENT_STATUS = {
    scheduled: 'scheduled',
    live: 'ongoing',
    ended: 'event_ended',
    cancelled: 'cancelled',
    drafted: 'drafted'
};

export const TICKET_STATUS = {
    scheduled: 'scheduled',
    live: 'live',
    soldOut: 'sold_out',
    saleEnded: 'sale_ended',
    commingSoon: 'coming_soon'
};

export const EVENT_TYPES = {
    singleDay: 'single_day',
    multiDay: 'multi_day',
    continuous: 'continuous'
};

export default function useEvent() {
    const eventData = useSelector((state) => state.event?.eventData);
    const { tickets } = useSelector((state) => state.ticket);

    const event = useMemo(() => {

        const isBasicDetailsCompleted = Boolean(eventData?.is_publishable?.details === 1)
        const isScheduleCompleted = Boolean(eventData?.is_publishable?.schedule === 1)
        const isDescriptionCompleted = Boolean(eventData?.is_publishable?.description === 1)
        const isMediaCompleted = Boolean(eventData?.is_publishable?.media === 1)
        const isLocationCompleted = Boolean(eventData?.is_publishable?.location === 1)
        const allEventDetailsCompleted = isBasicDetailsCompleted && isScheduleCompleted && isDescriptionCompleted && isMediaCompleted && isLocationCompleted

        const isTicketCreated = Boolean(eventData?.is_publishable?.ticket === 1) || Boolean(eventData?.is_publishable?.tickets === 1)

        const isEventPublishedOnce = eventData?.was_published_before

        const isEventLive = eventData?.status === EVENT_STATUS.live
        const isEventDrafted = eventData?.status === EVENT_STATUS.drafted
        const isEventScheduled = eventData?.status === EVENT_STATUS.scheduled
        const isEventEnded = eventData?.status === EVENT_STATUS.ended
        const isEventCancelled = eventData?.status === EVENT_STATUS.cancelled

        // const isBankDetailsAddedForEvent = Boolean(eventData?.bank_detail_id);
        // const isCommissionPaidByEndUser = eventData?.commission_paid_by_end_user;
        // const isSACCodeAdded = Boolean(eventData?.sac_code_id);

        // For future use when backend implement keys in is_publishable
        const isSACCodeAdded = eventData?.is_publishable?.sacCode
        const isBankDetailsAddedForEvent = eventData?.is_publishable?.bankAttached
        const isCommissionPaidByEndUser = eventData?.is_publishable?.commissionPaidBy

        const hasTaxInvoiceDetailsProvided = eventData?.is_publishable?.taxInvoiceDetails

        return {
            isBankDetailsAddedForEvent,
            isCommissionPaidByEndUser,
            isSACCodeAdded,
            allEventDetailsCompleted,
            isBasicDetailsCompleted,
            isScheduleCompleted,
            isDescriptionCompleted,
            isMediaCompleted,
            isLocationCompleted,
            isTicketCreated,
            hasTaxInvoiceDetailsProvided,
            isEventPublishedOnce,
            isEventLive,
            isEventDrafted,
            isEventScheduled,
            isEventEnded,
            isEventCancelled
        };
    }, [eventData]);


    const ticket = useMemo(() => {
        if (!Array.isArray(tickets) || tickets.length === 0) {
            return { isPaidTicketCreated: false };
        }

        const isPaidTicketCreated = tickets.some(
            (t) => Number(t?.price) > 0
        );

        const isAnyTicketSold = tickets.some(
            (t) => Number(t?.ticket_sold) > 0
        );

        return {
            isPaidTicketCreated,
            isAnyTicketSold
        };
    }, [tickets]);

    // console.log("Event Details: ", JSON.stringify(event, null, 2));
    // console.log("Ticket Details: ", JSON.stringify(ticket, null, 2));
    // console.log("Combined Details: ", JSON.stringify(tickets, null, 2));

    return {
        ...event,
        ...ticket
    };
}